// Global Instructions Rule Applied!

import { FundraisingState } from '../../interfaces/fundraising.ts'

const prospectRowMatchesId = (
  prospect: { id?: string; prospects__id?: string; [key: string]: any },
  prospectIdString: string
): boolean => {
  const candidates = [prospect.id, prospect.prospects__id, prospect['prospects__id']]
    .filter((v) => v != null && v !== '')
    .map((v) => String(v))
  return candidates.some((c) => c === prospectIdString)
}

/**
 * Selector function to find a prospect by ID in pipeline.data and fundraising.data arrays
 * Searches pipeline.data first, then data (mirrors selectDealById)
 * Returns the first match found, or undefined if not found
 *
 * Usage:
 * const prospect = useSelector((state) => selectProspectById(state, prospectId))
 */
export const selectProspectById = (
  state: { fundraising: FundraisingState },
  prospectId: string | number | null | undefined
) => {
  if (!prospectId || !state.fundraising) return undefined

  const prospectIdString = prospectId.toString()

  // Search pipeline.data first
  const pipelineProspect = state.fundraising.pipeline?.data?.find((p) =>
    prospectRowMatchesId(p, prospectIdString)
  )
  if (pipelineProspect) return pipelineProspect

  // If not found in pipeline, search data
  return state.fundraising.data.find((p) => prospectRowMatchesId(p, prospectIdString))
}
